/**
 * Device Views Index
 *
 * Exports maps for device-specific view and screen components
 * Used by DeviceScreen2 to render appropriate UI per device type
 */

// View components (render inside DeviceScreen2's card layout)
import {
    KeepConnectView,
    PowerPalView,
    WaterPalView,
    ClimatePalView,
    ComputerPalView,
    RouterPalView,
} from './views';

// Screen components (complete override - bypass base layout)
import { PumpPalScreen } from './screens';

// Device Modals shared component
export { default as DeviceModals } from './DeviceModals';

/**
 * View Map - Device type to view component
 * These render inside DeviceScreen2's layout (status card, info card, etc.)
 */
export const deviceViewMap = {
    "0": KeepConnectView,    // Keep Connect (Rebooter)
    "1": PowerPalView,       // Power Pal
    "2": WaterPalView,       // Water Pal
    "3": ClimatePalView,     // Climate Pal
    "4": ComputerPalView,    // Computer Pal
    "5": RouterPalView,      // Router Pal
};

/**
 * Screen Map - Device type to full screen override component
 * These completely replace DeviceScreen2's layout
 */
export const deviceScreenMap = {
    "6": PumpPalScreen,    // Pump Check (full override)
};

/**
 * Icon Map - Device type to icon asset
 */
export const deviceIconMap = {
    "0": require('../../assets/kcIcon.png'),
    "1": require('../../assets/ppIcon.png'),
    "2": require('../../assets/wpIcon.png'),
    "3": require('../../assets/cpIcon.png'),
    "4": require('../../assets/compPal.png'),
    "5": require('../../assets/rpIcon.png'),
    "6": require('../../assets/pumpIcon.png'), // TODO: Add pumpIcon.png asset
};

/**
 * Device Name Map - Device type to display name
 */
export const deviceNameMap = {
    "0": "Keep Connect",
    "1": "Power Pal",
    "2": "Water Pal",
    "3": "Climate Pal",
    "4": "Computer Pal",
    "5": "Router Pal",
    "6": "Pump Pal",
};

/**
 * Check if a device type has a full screen override
 */
export const hasScreenOverride = (deviceType) => {
    return deviceType in deviceScreenMap;
};

/**
 * Get the appropriate component for a device type
 * Returns { type: 'screen' | 'view', component: Component }
 */
export const getDeviceComponent = (deviceType) => {
    if (deviceType in deviceScreenMap) {
        return { type: 'screen', component: deviceScreenMap[deviceType] };
    }
    if (deviceType in deviceViewMap) {
        return { type: 'view', component: deviceViewMap[deviceType] };
    }
    return { type: 'view', component: null };
};
